import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import Modals from '../../modal';
import AppsUtils from '../../apps/utils';
import { Box, CircularProgress } from '@material-ui/core';
var APP = 'com.ecrion.ai';

var AIFrame = function AIFrame(_ref) {
  var onClose = _ref.onClose,
      type = _ref.type,
      id = _ref.id,
      onEvent = _ref.onEvent,
      rest = _objectWithoutProperties(_ref, ["onClose", "type", "id", "onEvent"]);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loaded = _React$useState2[0],
      setLoaded = _React$useState2[1];

  var src = AppsUtils.redirect(APP, "/embed/".concat(type, "/").concat(id));
  React.useEffect(function () {
    var handleMsg = function handleMsg(message) {
      var aiMsg = message.data && message.data.app === APP;
      if (!aiMsg) return;
      if (onEvent) onEvent(message.data.action, message.data.payload);

      if (message.data.action === 'close-panel') {
        onClose();
        return;
      }

      if (message.data.action === 'open-modal') {
        return Modals.open(message.data.payload);
      }
    };

    window.addEventListener('message', handleMsg, false);
    return function () {
      window.removeEventListener('message', handleMsg, false);
    };
  }, []);
  return React.createElement(React.Fragment, null, !loaded && React.createElement("div", null, React.createElement(Box, {
    top: "calc(50% - 25px)",
    left: "calc(50% - 25px)",
    position: "absolute",
    zIndex: 999
  }, React.createElement(CircularProgress, null))), React.createElement("iframe", Object.assign({
    style: {
      height: '100%',
      minHeight: '100%',
      maxHeight: '100%',
      border: 'none',
      maxWidth: '100%',
      width: '100%',
      opacity: loaded ? 1 : 0
    },
    onLoad: function onLoad() {
      setLoaded(true);
    },
    src: src
  }, rest)));
};

AIFrame.defaultProps = {};
export default AIFrame;